import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateUser } from '../state_user';

export const remote_user_settings_update_password = createAsyncThunkSafe<DTO_RESPONSE__success, string>(
  ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_PASSWORD,
  async (password): Promise<DTO_RESPONSE__success> => {
    let response = await send_to_server<DTO_RESPONSE__success>(ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_PASSWORD, password);
    return response;
  },
);

export function int_remote_user_settings_update_password(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_settings_update_password.pending, state => {})
    .addCase(remote_user_settings_update_password.rejected, (state, action) => {})
    .addCase(remote_user_settings_update_password.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__success>) => {
      state.is_password_set = true;
    });
}
